var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100vw","height":"100vh"}},[_c('div',{staticStyle:{"width":"100vw","height":"100vh"},attrs:{"id":"map"}},[_c('div',{attrs:{"id":"mouse-position"}})]),_c('div',{attrs:{"id":"key"}})])
}]

export { render, staticRenderFns }